module.exports = __webpack_public_path__ + "static/media/burn.c4d92622.svg";